import React, { ReactNode, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ChevronUpIcon } from 'src/editor/shared/icons/chevron-up-icon'
import { twMerge } from 'tailwind-merge'

export interface DropdownProps {
  title: string
  children?: ReactNode
  isDisabled?: boolean
  className?: string
  classNameDropdown?: string
}

export const Dropdown = ({
  title,
  children,
  isDisabled,
  className,
  classNameDropdown,
}: DropdownProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const contentRef = useRef<HTMLDivElement>(null)
  const [height, setHeight] = useState('0px')
  const { t } = useTranslation()

  useEffect(() => {
    if (contentRef.current) {
      setHeight(isOpen ? `${contentRef.current.scrollHeight}px` : '0px')
    }
  }, [isOpen])

  return (
    <div
      className={twMerge(
        'overflow-hidden rounded-[6px] border-[1px] border-inputBorder border-solid transition-colors hover:border-inputBorderHover',
        className,
      )}
    >
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={twMerge(
          'relative flex w-full cursor-pointer flex-wrap items-center justify-between border-transparent border-b-[1px]! bg-white p-2.5 px-4 outline-none transition-all duration-100',
          isOpen
            ? 'border-inputBorder hover:border-inputBorderHover'
            : 'border-transparent',
        )}
      >
        <span className="text-M text-textTertiary">{t(title)}</span>

        <ChevronUpIcon
          className={twMerge(
            'h-4 w-4 transition-transform duration-150',
            isOpen ? 'rotate-0' : 'rotate-180',
            isDisabled
              ? '[&>path]:stroke-iconDisabled'
              : '[&>path]:stroke-iconTertiary',
          )}
        />
      </button>

      <div
        ref={contentRef}
        style={{
          height,
          transition: 'height 300ms ease',
        }}
        className="overflow-hidden"
      >
        <div className={twMerge('p-4 pb-2.5', classNameDropdown)}>
          {children}
        </div>
      </div>
    </div>
  )
}
